import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlyFreelyConstants } from '../constants';
import { NotamDto, OrganisationIdentifierDto } from '../model/api';
import { ORGANIASTION_IDENTIFIER_LOOKUP } from './organisation.service';
import { httpParamSerializer } from './service.helpers';

export const notamProviderNameLookup = {
    ['ASA']:
        ORGANIASTION_IDENTIFIER_LOOKUP[
            OrganisationIdentifierDto.Integration.ASA
        ]
};

@Injectable({
    providedIn: 'root'
})
export class NotamService {
    private baseUrl: string;

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.API_URL;
    }

    findNotamsForMission(location: string[], missionId: number) {
        return this.http.get<NotamDto[]>(`${this.baseUrl}/webapi/notams`, {
            params: httpParamSerializer({ location, missionId })
        });
    }

    findNotamsByJurisdiction(location: string[], jurisdictionId: number) {
        return this.http.get<NotamDto[]>(`${this.baseUrl}/webapi/notams`, {
            params: httpParamSerializer({ location, jurisdictionId })
        });
    }
}
